import { render, staticRenderFns } from "./positions.vue?vue&type=template&id=2be4a596&scoped=true&"
import script from "./positions.vue?vue&type=script&lang=js&"
export * from "./positions.vue?vue&type=script&lang=js&"
import style0 from "./positions.vue?vue&type=style&index=0&id=2be4a596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4a596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be4a596')) {
      api.createRecord('2be4a596', component.options)
    } else {
      api.reload('2be4a596', component.options)
    }
    module.hot.accept("./positions.vue?vue&type=template&id=2be4a596&scoped=true&", function () {
      api.rerender('2be4a596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions.vue"
export default component.exports